import * as React from "react";
const NewsClock = (props) => (
  <svg
    width={15}
    height={16}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.29199 0.931869C3.51765 0.751341 3.55424 0.42206 3.37371 0.1964C3.19318 -0.0292606 2.8639 -0.0658473 2.63824 0.114681L0.894055 1.51003C0.668395 1.69056 0.631808 2.01984 0.812336 2.2455C0.992864 2.47116 1.32215 2.50775 1.54781 2.32722L3.29199 0.931869Z"
      fill="white"
    />
    <path
      d="M12.3618 0.114681C12.1361 -0.0658473 11.8068 -0.0292606 11.6263 0.1964C11.4458 0.42206 11.4823 0.751341 11.708 0.931869L13.4522 2.32722C13.6779 2.50775 14.0071 2.47116 14.1877 2.2455C14.3682 2.01984 14.3316 1.69056 14.1059 1.51003L12.3618 0.114681Z"
      fill="white"
    />
    <path
      d="M8.02326 5.407C8.02326 5.11801 7.78899 4.88374 7.5 4.88374C7.21102 4.88374 6.97675 5.11801 6.97675 5.407V8.34131C6.97675 8.56372 6.89177 8.77773 6.73919 8.93956L5.72393 10.0164C5.52568 10.2267 5.53543 10.5578 5.7457 10.7561C5.95597 10.9543 6.28713 10.9446 6.48538 10.7343L7.50064 9.65746C7.83631 9.30143 8.02326 8.83062 8.02326 8.34131V5.407Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 0.697692C3.35786 0.697692 0 4.05556 0 8.19769C0 12.3398 3.35786 15.6977 7.5 15.6977C11.6421 15.6977 15 12.3398 15 8.19769C15 4.05556 11.6421 0.697692 7.5 0.697692ZM1.04651 8.19769C1.04651 4.63353 3.93584 1.7442 7.5 1.7442C11.0642 1.7442 13.9535 4.63353 13.9535 8.19769C13.9535 11.7619 11.0642 14.6512 7.5 14.6512C3.93584 14.6512 1.04651 11.7619 1.04651 8.19769Z"
      fill="white"
    />
  </svg>
);
export default NewsClock;
